import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import ZoomEmbeddedProp from '../propTypes/zoomEmbeddedProp';
import translate from '../translate';

function ZoomEmbeddedPlayer({ t, webinar, isDone, onClickLessonAsDone }) {
  const [showVideo, setShowVideo] = useState(false);
  useEffect(() => setShowVideo(true), []);

  const containerStyle = { width: '100%', height: '100%' };

  const handleLessonDoneClick = () => {
    onClickLessonAsDone();
  };

  const handleStatus = (w, lessonIsDone) => {
    const startDate = moment.utc(w.startDate);
    const endDate = moment.utc(w.startDate + w.duration);
    let status = 'unStarted';
    if (startDate.valueOf() > moment.utc().valueOf()) {
      status = 'unStarted';
    } else if (startDate.valueOf() < moment.utc().valueOf() && moment.utc().valueOf() < endDate.valueOf()) {
      status = 'onGoing';
    } else if (moment.utc().valueOf() > endDate.valueOf()) {
      status = 'finished';
    }
    switch (status) {
      case 'unStarted':
        return (
          <>
            <div className="webinar-description">{t('academy_webinar_unStarted')}</div>
            <div className="webinar-date">{startDate.format('YYYY MMM DD, HH:mm')}</div>
          </>
        );
      case 'onGoing':
        return (
          <>
            <div className="webinar-description">{t('academy_webinar_onGoing')}</div>
            <div className="webinar-date">{startDate.format('YYYY MMM DD, HH:mm')}</div>
          </>
        );
      case 'finished':
        return (
          <>
            <div className="webinar-description">{t('academy_webinar_finished')}</div>
            <button
              type="button"
              className="webinar-button btn m-btn--pill btn-dynamic"
              onClick={handleLessonDoneClick}
              disabled={lessonIsDone}
            >
              {t('academy_mark_lesson_done')}
            </button>
          </>
        );
      default: return (<></>);
    }
  };

  return (
    <>
      {showVideo ? (
        <div className="webinar-container">
          <div
            className="iframe-container"
            style={{
              overflow: 'hidden',
              position: 'relative',
              'padding-top': '56.25%',
            }}
          >
            <iframe
              title={webinar.id}
              allow="microphone; camera"
              style={{
                order: 0,
                height: '100%',
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%',
              }}
              src={webinar.url}
              frameBorder="0"
            />
          </div>
          { handleStatus(webinar, isDone) }
        </div>
      ) : (
        <div style={containerStyle} />
      )}
    </>
  );
}

ZoomEmbeddedPlayer.propTypes = {
  t: PropTypes.func.isRequired,
  webinar: PropTypes.shape(ZoomEmbeddedProp.propType).isRequired,
  isDone: PropTypes.bool,
  onClickLessonAsDone: PropTypes.func,
};

ZoomEmbeddedPlayer.defaultProps = {
  isDone: false,
  onClickLessonAsDone: () => {},
};

export default translate(ZoomEmbeddedPlayer);
